import { HttpService } from '@/infra'
import type { TAtendimento } from '@/types/atendimento'

export type TCriarAtendimentoBody = {
  clienteId?: string | null
  codigoOportunidade?: string
}

export type TCriarAtendimentoResponse = {
  id: string
  message: string
  date: string
  data: TAtendimento
}

export class CriarAtendimentoService extends HttpService {
  async execute(body: TCriarAtendimentoBody): Promise<TCriarAtendimentoResponse> {
    const response = await this.http.post<TCriarAtendimentoResponse>('api/v2/Atendimento', body)
    return response.data
  }
}
